// extracted by mini-css-extract-plugin
module.exports = {"message":"style_message__2X62k","value":"style_value__2mFZN"};